/**
 * Returns the Mile from meters.
 */
export const meterToMile = (meters: number | string): string => {
	const miles = Number(meters) / 1609.344;
	return `${miles.toFixed(1)}mi`;
};
